import { create } from 'zustand'

/** Yêu cầu đổi giai đoạn cần người dùng điền trường bổ sung trước (hộp thoại ở components/shared/stage-fields-dialog.tsx). */
export interface StageChangeRequest {
  contactId: string
  toStage: string
  /** Tên khách để hiện trên hộp thoại / thông báo. */
  name?: string
  /** Gọi sau khi đổi giai đoạn thành công. */
  onDone?: () => void
}

interface State {
  request: StageChangeRequest | null
  open: (r: StageChangeRequest) => void
  close: () => void
}

export const useStageChangeStore = create<State>((set) => ({
  request: null,
  open: (request) => set({ request }),
  close: () => set({ request: null }),
}))
